// 編集か読み取りかで該当のmaterial-iconの名前を返す関数
const getIconNameFromMode = permissionStrings => {
  switch (permissionStrings) {
    case 'edit': {
      return 'edit'
    }
    case 'view': {
      return 'visibility'
    }
    default: {
      return 'visibility'
    }
  }
}

export default getIconNameFromMode
